import { apiRequest, invalidateCache } from './api.js';

export function createPlansService(helium) {
	const plansChannel = helium.factory('plans:list', { data: [], loading: false });
	
	const getAll = async (signal) => {
		return await apiRequest('/api/v1/admin/plans', { signal }, true);
	};
	
	const getById = async (planId, signal) => {
		return await apiRequest(`/api/v1/admin/plans/${planId}`, { signal });
	};
	
	const create = async (planData, signal) => {
		invalidateCache('/api/v1/admin/plans');
		return await apiRequest('/api/v1/admin/plans', {
			method: 'POST',
			body: JSON.stringify(planData),
			signal
		});
	};
	
	const update = async (planId, planData, signal) => {
		invalidateCache('/api/v1/admin/plans');
		return await apiRequest(`/api/v1/admin/plans/${planId}`, {
			method: 'PATCH',
			body: JSON.stringify(planData),
			signal
		});
	};
	
	const remove = async (planId, signal) => {
		invalidateCache('/api/v1/admin/plans');
		return await apiRequest(`/api/v1/admin/plans/${planId}`, {
			method: 'DELETE',
			signal
		});
	};
	
	return { plansChannel, getAll, getById, create, update, remove };
}
